<app-mainscreen>
    <div class="dashboard_block">
        <div class="dashboard_block_header">
            <app-simple-page-heading title="Dashboard" titleDiscription="Welcome to the Distributor Dashboard "></app-simple-page-heading>
        </div>
        <div class="dashboard_block_body">
            <div class="tabs_div">
                <ul class="justify-content-between align-items-center mb-0 flex-row rounded-top-0">
                    <li class="list-item w-auto" [ngClass]="{'active': activeTab == 1}" (click)="changeTab(1)">
                        Summary
                    </li> 
                    <li class="list-item w-auto" [ngClass]="{'active': activeTab == 2}" (click)="changeTab(2)">
                        Reseller
                    </li> 
                    <li class="list-item w-auto" [ngClass]="{'active': activeTab == 3}" (click)="changeTab(3)">
                        Agents
                    </li> 
                    <li class="list-item w-auto" [ngClass]="{'active': activeTab == 4}" (click)="changeTab(4)">
                        Customers
                    </li>            
                </ul>
            </div>
        </div>
    </div> 
    <div class="tabs_content">
        <div class="row mt-2">
            <div class="col d-flex align-items-center">
                <div class="title_div">
                    <h6 class="mb-0">Overview</h6>
                </div>
            </div>
            <div class="col">
                <app-date-range-picker [selectedStartDate]="this.selectedStartDate" [selectedEndDate]="this.selectedEndDate"  [selectedDateRange]="this.selectedDateRange" (dateRangeChange)="onDateRangeChange($event)" [id]="'dateRangePicker_'"></app-date-range-picker>
            </div>
        </div>
        <div id="comprehensive" class="tab-pane" [ngClass]="{'d-block': activeTab == 1,'d-none' : activeTab !=1}">
            <app-dashboard-sales-panel (policyTypeCheckChange)="onPolicyTypeCheckOutput($event)" [userType]="3"></app-dashboard-sales-panel>
        </div>
        <div id="comprehensive" class="tab-pane" [ngClass]="{'d-block': activeTab == 2,'d-none' : activeTab !=2}">
            <app-dashboard-reseller-panel></app-dashboard-reseller-panel>
        </div>
        <div id="comprehensive" class="tab-pane pb-4" [ngClass]="{'d-block': activeTab == 3,'d-none' : activeTab !=3}">
            <app-dashboard-agent-panel></app-dashboard-agent-panel>
        </div>
        <div id="comprehensive" class="tab-pane w-100 pb-3" [ngClass]="{'d-block': activeTab == 4,'d-none' : activeTab !=4}">
            <app-dashboard-customer-panel></app-dashboard-customer-panel>
        </div>
    </div>
</app-mainscreen>